'use client';

import React from "react";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
} from "recharts";

// Dual-series monthly trend: enquiries received vs signed up.
// Used on Operator Desktop and the Owner view (pilot feedback, 11 Jun 2026).
export const TrendLineChart = ({ data, height = 220 }) => (
  <div data-testid="trend-line-chart" style={{ width: "100%", height, minHeight: height }}>
    <ResponsiveContainer>
      <LineChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
        <XAxis dataKey="month" tick={{ fontSize: 12, fill: "#57534e" }} axisLine={false} tickLine={false} />
        <YAxis allowDecimals={false} tick={{ fontSize: 12, fill: "#57534e" }} axisLine={false} tickLine={false} />
        <Tooltip cursor={{ stroke: "#e7e5e4" }} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Line type="monotone" dataKey="enquiries" name="Enquiries" stroke="#d97706" strokeWidth={2} dot={{ r: 3 }} activeDot={{ r: 5 }} />
        <Line type="monotone" dataKey="signed" name="Signed up" stroke="#1c1917" strokeWidth={2} dot={{ r: 3 }} activeDot={{ r: 5 }} />
      </LineChart>
    </ResponsiveContainer>
  </div>
);
